{
	"printDate": "Emitido el día",
	"reportPeriod": "Periodo del informe",
	"emissionInfo": "Emitido por",
	"eventDate": "Fecha del evento"
}
